export default {
  "navigator": {
    "home": "Home",
    "achievements": "Research Achievements",
    "researcher": "Researchers",
    "ins": "Research Institutions",
    "isme": "Claim Achievements",
    "apply": "Service Application"
  },
  "home": {
    "title": "Shenzhen MSU-BIT University Academic Research Platform",
    "introduce": "Shenzhen Beihang-Moscow University is a cooperative institution established by the consensus of Chinese President Xi Jinping and Russian President Vladimir Putin, in collaboration with the Shenzhen Municipal Government, Beijing Institute of Technology, and Moscow State University. The university aims to build a world-class international research-oriented university with unique features, focusing on elite education, high-level scientific research, and innovation activities. Officially established in October 2016, the university admitted its first batch of undergraduate and master's students in 2017, doctoral students in 2018, and was approved for a postdoctoral innovation practice base in 2020. In 2021, it was selected as a key institution for the construction of high-level disciplines in Guangdong Province.",
    "insRepository":"Institutional Repository",
    "article": "Articles",
    "patent": "Patents",
    "researcher": "Researchers",
    "software_copyright": "Software Copyright",
    "award": "Awards",
    "project": "Projects",
    "report": "Reports",
    "book": "Books",
    "data": "Data",
    "news": {
      "left_title": "Latest Research Achievements",
      "right_title": "Institutional Research Themes",
      "more": "More"
    },
    "login": "Login",
    "signout": "Sign Out",
    "settings": "Account Settings",
    "profile": "My Profile",
    "historySearch": "Search History",
    "history": "Browsing History",
    "search": {
      "placeholder": "Discover what interests you...",
      "advanceSearch": "Advanced Search",
      "search": "Search",
      "topic": "Topic"
    },
    "appJoin": "Apply to Join",
    "ins": "Institution",
    "colleges": "Colleges",
    "cas": "Chinese Academy of Sciences",
    "scholar_count": "Number of Scholars",
    "fruit_count": "Number of Achievements",
    journal_article_submit:"Journal paper deposit",
    person_fruit_submit:"Personal Achievement Deposit",
  },
  "explore": {
    "category": "Category Browse",
    "years": "Time Range",
    "start": "Start Time",
    "end": "End Time",
    "to": "to",
    "enter": "Enter",
    "exact": "Exact",
    "fuzzy": "Fuzzy",
    "reset": "Reset Conditions",
    "article": {
      "title": "Title",
      "keywords": "Keywords",
      "author": "Author",
      "institution": "Institution",
      "publication": "Publication",
      "abstract": "Abstract",
      "doi": "DOI",
      "type": "Paper Type",
      "year": "Publication Year",
      "collect": "Core Collection",
      "lang": "Language",
      "authorIns": "Author Institution",
      "fundIns": "Funding Institution",
      "licence": "License",
      "subject": "Subject Area"
    },
    "patent": {
      "title": "Patent Name",
      "inventor": "Inventor",
      "applicant": "Patent Holder",
      "abstract": "Abstract",
      "apply_number": "Application Number",
      "issue_number": "Publication Number",
      "apply_year": "Application Year",
      "issue_year": "Publication Year",
      "subject": "Field Classification",
      "type": "Patent Type",
      "country": "Country/Region",
      "ipc": "IPC Classification",
      "cpc": "CPC Classification"
    },
    "report": {
      "title": "Title",
      "keywords": "Keywords",
      "abstract": "Abstract",
      "type": "Report Type",
      "institution": "Institution",
      "year": "Report Year",
      "source": "Report Source",
      "subject": "Subject Area"
    },
    "book": {
      "title": "Book Title",
      "publisher": "Publisher",
      "author": "Author",
      "keywords": "Keywords",
      "abstract": "Abstract",
      "type": "Book Type",
      "year": "Publication Year",
      "ins": "Chief Editing Institution",
      "subject": "Subject Area"
    },
    "scienceData": {
      "title": "Title",
      "keywords": "Keywords",
      "author": "Author",
      "abstract": "Abstract",
      "subject": "Subject Area",
      "year": "Publication Year",
      "ins": "Institution",
      "licence": "License",
      "data_type": "Data Type",
      "file_type": "File Format"
    },
    "project": {
      "title": "Title",
      "keywords": "Keywords",
      "author": "Lead Person",
      "fundIns": "Funding Institution",
      "country": "Funding Country",
      "abstract": "Abstract",
      "underIns": "Undertaking Institution",
      "startYear": "Start Year",
      "status": "Project Status",
      "type": "Project Type",
      "lang": "Project Language",
      "fundAmout": "Funding Amount",
      "subject": "Subject Area"
    },
    "award": {
      "title": "Title",
      "abstract": "Abstract",
      "level": "Award Level",
      "category": "Award Category",
      "year": "Award Year",
      "ti_ins": "Nominating Institution",
      "ins": "Awarding Institution"
    },
    "software": {
      "title": "Title",
      "abstract": "Abstract",
      "author": "Copyright Holder",
      "inventor": "Developer",
      "year": "Certification Year",
      "ins": "Certification Institution",
      "method": "Acquisition Method",
      "range": "Rights Scope",
      "registId": "Registration Number",
      "getMethod": "Rights Acquisition Method"
    },
    "institution": {
      "title": "Institution Name",
      "subject": "Research Field",
      "intro": "Introduction",
      "city": "City",
      "country": "Country",
      "tag": "Tags",
      "type": "Institution Type"
    },
    "all_selected": "Select All",
    "date_sorted": "Date Sort",
    "related_sorted": "Relevance Sort",
    "fulltext": "Full Text",
    "unit": "Data Items",
    "filter": "Filter",
    "all": "All",
    "related": "Relevance",
    "name": "Name",
    "count_paper": "Number of Papers",
    "asc": "Ascending",
    "desc": "Descending",
    "reasearch": "Research Direction",
    "people_category": "Personnel Category",
    "research_unit": "Research Unit",
    "units": "Please Select Research Unit",
    "group": "Please Select Research Group",
    "empty": "No Data Available",
    "selectCondtion": "Filter Conditions",
    "allDelete": "Clear All",
    "selected": "Selected",
    "cancelSelected": "Cancel Selection",
    "exportText": "Export"
  },
  "service_apply": {
    label1:"PubScholar Institutional Knowledge Cloud",
    label1_1:"The PubScholar institutional knowledge cloud platform is based on the needs of the Chinese Academy of Sciences in three aspects: institutional asset management and knowledge services, institutional competition evaluation and discipline evaluation, and platform network information security. It uses big data and artificial intelligence technology to improve the management level and utilization depth of institutional knowledge achievements, provide data asset management of institutional scientific research achievements, external display of institutional scientific research strength, multi-dimensional statistical analysis of team achievements, support institutional competition and discipline competition evaluation, and help scientific researchers effectively collect high-level academic resources, and open up the sharing and utilization of scientific research achievements. The platform will be officially launched in November 2023, and currently more than 20 research institutions and universities have settled in.",
    "label2": "PubScholar invites institutions to join its knowledge cloud platform",
    "label3": "Applicants for the Institutional Knowledge Cloud Service Platform are generally from the institution's science and technology department or library management personnel. The applicant needs to first fill out the form",
    "label3_1": "and send it to the platform administrator. After review, the platform administrator will connect with the applicant to integrate institution data and activate the institutional repository cloud service.",
    "label4": "Application process for institutional settlement (applicants are generally from the institution's technology department or library management personnel)",
    "label5": "(1) The applicant visits the Institutional Knowledge Cloud Platform to download",
    "label5_1": "and fill it out.",
    "label6": "(2) The applicant sends the completed application form to the platform administrator's email at hujy@mail.las.ac.cn.",
    "label7": "(3) The platform administrator will review the application, with a review period within 3 working days.",
    "label8": "(4) After review, the platform administrator will connect with the applicant for data integration, completing the import, cleaning, and standardization of institutional data.",
    "label9": "(5) The platform administrator will activate the institutional repository cloud service for the applying institution and grant management permissions for the institutional repository backend management platform.",
    "label10": "Download Service Application Form",
    "label11": " <Institutional Knowledge Cloud Service Application Form> ",
    "label12": "Platform contact information",
    label13: 'If you have any requests, questions or suggestions while using this platform, you can contact us through the following methods, and we will handle your issues seriously.',
    label14: 'Email: hujy@mail.las.ac.cn ； zhangrumin@mail.las.ac.cn',
    label15: 'Phone: 010-82628382'
  },
  "footer": {
    "operator": "Chinese Academy of Sciences Literature and Information Center",
    "operatorLabel": "Operating Unit:",
    "contactAddressLabel": "Contact Address:",
    "contactAddress": "No. 33, North Fourth Ring West Road, Haidian District, Beijing",
    "contactNumberLabel": "Contact Number:",
    "contactNumber": "010-82628382",
    "copyright": "© Chinese Academy of Sciences Literature and Information Center"
  }
}
